import { useExperienceField } from '../hooks/useExperienceField';

// ─── Experience – Core ─────────────────────────────────────────────────────────

export const useExperienceId = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.id,
        (p, v) => ({ ...p, id: v })
    );

export const useExperiencePrincipalId = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.principalId,
        (p, v) => ({ ...p, principalId: v })
    );

export const useExperienceProjectTypeId = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.projectTypeId,
        (p, v) => ({ ...p, projectTypeId: v })
    );

export const useExperienceExperienceTypeId = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.experienceTypeId,
        (p, v) => ({ ...p, experienceTypeId: v })
    );

export const useExperiencePropertyTypeId = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.propertyTypeId,
        (p, v) => ({ ...p, propertyTypeId: v })
    );

export const useExperienceTwoToFourUnitTypeId = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.twoToFourUnitTypeId,
        (p, v) => ({ ...p, twoToFourUnitTypeId: v })
    );

export const useExperienceLender = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.lender,
        (p, v) => ({ ...p, lender: v })
    );

export const useExperienceAddressStreet1 = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.address?.street1,
        (p, v) => ({
            ...p,
            address: {
                ...(p.address ?? {}),
                street1: v,
            },
        })
    );

export const useExperienceAddressStreet2 = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.address?.street2,
        (p, v) => ({
            ...p,
            address: {
                ...(p.address ?? {}),
                street2: v,
            },
        })
    );

export const useExperienceAddressCity = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.address?.city,
        (p, v) => ({
            ...p,
            address: {
                ...(p.address ?? {}),
                city: v,
            },
        })
    );

export const useExperienceAddressState = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.address?.state,
        (p, v) => ({
            ...p,
            address: {
                ...(p.address ?? {}),
                state: v,
            },
        })
    );

export const useExperienceAddressZipCode = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.address?.zipCode,
        (p, v) => ({
            ...p,
            address: {
                ...(p.address ?? {}),
                zipCode: v,
            },
        })
    );

export const useExperienceAddressCounty = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.address?.county,
        (p, v) => ({
            ...p,
            address: {
                ...(p.address ?? {}),
                county: v,
            },
        })
    );

export const useExperienceStillOwn = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.stillOwn,
        (p, v) => ({ ...p, stillOwn: v })
    );

export const useExperienceDateSold = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.dateSold,
        (p, v) => ({ ...p, dateSold: v })
    );

export const useExperienceDateSoldTypeId = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.dateSoldTypeId,
        (p, v) => ({ ...p, dateSoldTypeId: v })
    );

export const useExperienceSalesPrice = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.salesPrice,
        (p, v) => ({ ...p, salesPrice: v })
    );

export const useExperienceBudget = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.budget,
        (p, v) => ({ ...p, budget: v })
    );

export const useExperienceUnitCount = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.unitCount,
        (p, v) => ({ ...p, unitCount: v })
    );

export const useExperienceVerificationStatusTypeId = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.verificationStatusTypeId,
        (p, v) => ({ ...p, verificationStatusTypeId: v })
    );

export const useExperienceIsVerified = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.isVerified,
        (p, v) => ({ ...p, isVerified: v })
    );

export const useExperienceCommercialConsiderationAcknowledged = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.commercialConsiderationAcknowledged,
        (p, v) => ({ ...p, commercialConsiderationAcknowledged: v })
    );

export const useExperienceHomeConstructedAfterPurchase = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.homeConstructedAfterPurchase,
        (p, v) => ({ ...p, homeConstructedAfterPurchase: v })
    );

export const useExperienceContent = (experienceId: string | undefined) =>
    useExperienceField(
        experienceId,
        (p) => p.content,
        (p, v) => ({ ...p, content: v })
    );
